(function(){
if(window.__xlb)return; window.__xlb=1;
var C=window.__XLB_CFG||{}, ROOT=C.root||'main', MINW=C.minw||190;
var items=[],idx=0,ov,imgEl,phEl,capEl,capBox,cntEl,spin,hint,btnPrev,btnNext,zBox,stage;
var sc=1,fit=1,tx=0,ty=0,nat={w:0,h:0},lock=null,lastFocus=null,tok=0;
var ptr=new Map(),pinch=null,drag=null,moved=0,lastTap=0,collectT=0;
var FINE=matchMedia('(pointer:fine)').matches;
var hintRaf=0,hx=0,hy=0,hintOn=0;
function hideHint(){
  hintOn=0;
  if(hintRaf){cancelAnimationFrame(hintRaf);hintRaf=0;}
  if(hint)hint.classList.remove('on');
}
function positionHint(e){
  if(!hint)return;
  if(e){hx=e.clientX;hy=e.clientY;}
  var r=hint.getBoundingClientRect();
  var x=Math.max(8,Math.min(hx+18,window.innerWidth-r.width-8));
  var y=Math.max(8,Math.min(hy+18,window.innerHeight-r.height-8));
  hint.style.transform='translate3d('+x+'px,'+y+'px,0)';
}

function scope(){return document.querySelector(ROOT)||document.querySelector('main')||document.body;}
function ok(im){
  if(!im||im.hasAttribute('data-no-zoom'))return false;
  if(im.closest('a'))return false;
  /* 作用域已经限定在文章容器里,所以不排除 <header>(文章封面图也要能放大);只挡站点页眉页脚 */
  if(im.closest('[data-nz-card],[data-sk-card],[data-no-zoom],.xlb-skip,.xlb,[role="banner"],[role="contentinfo"],.skh,.nzh'))return false;
  var w=im.getBoundingClientRect().width||im.naturalWidth||0;
  return w>=MINW;
}
function hi(src){
  try{var u=new URL(src,location.href);
    if(!/\/cdn\/shop\/|cdn\.shopify\.com/.test(u.href))return u.href;
    u.searchParams.delete('height');u.searchParams.delete('crop');
    u.searchParams.set('width','2400');return u.href;
  }catch(e){return src;}
}
function collect(){
  var all=[].slice.call(scope().querySelectorAll('img'));
  /* 懒加载图在载入前 rect 宽=0(主题没给 img 显式宽),必须等它 load 完再重判 */
  all.forEach(function(im){
    if(im.__xlbL)return; im.__xlbL=1;
    if(!im.complete)im.addEventListener('load',recollect,{once:true,passive:true});
  });
  items=all.filter(ok);
  items.forEach(function(im,i){
    im.dataset.xlbI=i;
    if(!im.classList.contains('xlb-z')){
      im.classList.add('xlb-z');
      im.setAttribute('tabindex','0');
      im.setAttribute('aria-haspopup','dialog');
    }
  });
}
function recollect(){clearTimeout(collectT);collectT=setTimeout(collect,150);}

function build(){
  ov=document.createElement('div'); ov.className='xlb'; ov.setAttribute('role','dialog');
  ov.setAttribute('aria-modal','true'); ov.setAttribute('aria-label',C.label||'Image viewer');
  ov.innerHTML=
   '<div class="xlb-bg"></div>'+
   '<div class="xlb-stage"><img class="xlb-ph" alt="" aria-hidden="true"><img class="xlb-img" alt=""><div class="xlb-spin" aria-hidden="true"></div></div>'+
   '<div class="xlb-top"><div class="xlb-cnt"></div>'+
     '<div class="xlb-tools">'+
       '<button type="button" class="xlb-b" data-a="out" aria-label="Zoom out">&#8722;</button>'+
       '<div class="xlb-zv" aria-live="off">100%</div>'+
       '<button type="button" class="xlb-b" data-a="in" aria-label="Zoom in">&#43;</button>'+
       '<button type="button" class="xlb-b xlb-x" data-a="close" aria-label="Close viewer">&#10005;</button>'+
     '</div></div>'+
   '<button type="button" class="xlb-nav xlb-prev" aria-label="Previous image">&#8249;</button>'+
   '<button type="button" class="xlb-nav xlb-next" aria-label="Next image">&#8250;</button>'+
   '<div class="xlb-cap"><span></span></div>';
  document.documentElement.appendChild(ov);      /* 挂 <html> 而非 body:躲开 body{zoom:.8} */
  imgEl=ov.querySelector('.xlb-img'); phEl=ov.querySelector('.xlb-ph');
  capEl=ov.querySelector('.xlb-cap>span'); capBox=ov.querySelector('.xlb-cap'); cntEl=ov.querySelector('.xlb-cnt');
  spin=ov.querySelector('.xlb-spin'); zBox=ov.querySelector('.xlb-zv');
  btnPrev=ov.querySelector('.xlb-prev'); btnNext=ov.querySelector('.xlb-next');
  stage=ov.querySelector('.xlb-stage');
  ov.addEventListener('click',function(e){
    var b=e.target.closest('[data-a]');
    if(b){var a=b.dataset.a; if(a==='close')close(); else zoomBy(a==='in'?1.6:1/1.6); return;}
    if(e.target===stage||e.target.classList.contains('xlb-bg'))close();
  });
  btnPrev.addEventListener('click',function(){go(-1);});
  btnNext.addEventListener('click',function(){go(1);});
  stage.addEventListener('wheel',onWheel,{passive:false});
  stage.addEventListener('pointerdown',onDown);
  stage.addEventListener('pointermove',onMove,{passive:false});
  stage.addEventListener('pointerup',onUp);
  stage.addEventListener('pointercancel',onUp);
  stage.addEventListener('dblclick',function(e){e.preventDefault();toggleZoom(e.clientX,e.clientY);});
  ov.addEventListener('keydown',trap);
}
function trap(e){
  if(e.key!=='Tab')return;
  var f=[].slice.call(ov.querySelectorAll('button:not([hidden])'));
  if(!f.length)return;
  var i=f.indexOf(document.activeElement);
  e.preventDefault();
  f[(i+(e.shiftKey?-1:1)+f.length)%f.length].focus();
}
function open(i){
  hideHint();
  if(!ov)build();
  lastFocus=document.activeElement; idx=i;
  ov.classList.add('on'); document.documentElement.classList.add('xlb-open');
  lockScroll(); render(); fixCover();
  document.addEventListener('keydown',onKey,true);
  ov.querySelector('.xlb-x').focus({preventScroll:true});
}
function close(){
  hideHint();
  if(!ov||!ov.classList.contains('on'))return;
  ov.classList.remove('on'); ov.classList.remove('zoomed');
  document.documentElement.classList.remove('xlb-open');
  document.removeEventListener('keydown',onKey,true); unlockScroll();
  imgEl.removeAttribute('src'); phEl.removeAttribute('src');
  if(lastFocus&&lastFocus.focus)try{lastFocus.focus({preventScroll:true});}catch(e){}
}
/* 开屏后实测遮罩是否真盖满视口(body{zoom} / 固定定位怪癖),不足就自补 */
function fixCover(){
  ov.style.zoom='';
  requestAnimationFrame(function(){
    var w=ov.getBoundingClientRect().width;
    if(w){var k=window.innerWidth/w;
      if(k>0.2&&k<5&&Math.abs(k-1)>0.01)ov.style.zoom=String(k);}
    requestAnimationFrame(fitNow);
  });
}
function lockScroll(){
  var els=[document.documentElement,document.body];
  var pw=document.querySelector('.page-wrapper'); if(pw)els.push(pw);  /* NOZLOO 桌面滚动容器 */
  lock=els.map(function(el){return {el:el,o:el.style.overflow};});
  lock.forEach(function(r){r.el.style.overflow='hidden';});
}
function unlockScroll(){if(!lock)return;lock.forEach(function(r){r.el.style.overflow=r.o;});lock=null;}

function render(){
  var src=items[idx]; if(!src)return;
  var my=++tok, thumb=src.currentSrc||src.src, full=hi(thumb);
  capEl.textContent=src.getAttribute('alt')||'';
  capBox.hidden=!capEl.textContent;
  cntEl.textContent=items.length>1?(idx+1)+' / '+items.length:'';
  btnPrev.hidden=btnNext.hidden=items.length<2;
  imgEl.setAttribute('alt',src.getAttribute('alt')||'');
  phEl.src=thumb; phEl.style.visibility='visible';
  spin.classList.add('on'); imgEl.classList.remove('rdy');
  nat={w:src.naturalWidth||0,h:src.naturalHeight||0};
  var probe=new Image();
  probe.onload=function(){
    if(my!==tok)return;
    nat={w:probe.naturalWidth,h:probe.naturalHeight};
    imgEl.src=full; imgEl.classList.add('rdy');
    phEl.style.visibility='hidden'; spin.classList.remove('on'); fitNow();
  };
  probe.onerror=function(){
    if(my!==tok)return;
    nat={w:src.naturalWidth||1,h:src.naturalHeight||1};
    imgEl.src=thumb; imgEl.classList.add('rdy');
    phEl.style.visibility='hidden'; spin.classList.remove('on'); fitNow();
  };
  probe.src=full;
  if(items.length>1){var n=items[(idx+1)%items.length]; if(n)(new Image()).src=hi(n.currentSrc||n.src);}
}
function box(){var b=stage.getBoundingClientRect();return {w:b.width,h:b.height,l:b.left,t:b.top};}
function fitNow(){
  var b=box(); if(!nat.w||!nat.h||!b.w)return;
  fit=Math.min(b.w/nat.w,b.h/nat.h); if(fit>1)fit=1;
  sc=fit; tx=0; ty=0; apply();
}
function apply(){
  imgEl.style.width=nat.w+'px'; imgEl.style.height=nat.h+'px';
  clamp();
  imgEl.style.transform='translate3d('+tx+'px,'+ty+'px,0) scale('+sc+')';
  zBox.textContent=Math.round(sc/(fit||1)*100)+'%';
  ov.classList.toggle('zoomed',sc>fit*1.02);
}
function clamp(){
  var b=box(), w=nat.w*sc, h=nat.h*sc;
  var mx=Math.max(0,(w-b.w)/2), my=Math.max(0,(h-b.h)/2);
  tx=Math.max(-mx,Math.min(mx,tx)); ty=Math.max(-my,Math.min(my,ty));
}
function zoomAt(k,cx,cy){
  var b=box();
  var ns=Math.max(fit,Math.min(fit*8,sc*k)); if(ns===sc)return;
  var r=ns/sc, ox=(cx-b.l-b.w/2-tx), oy=(cy-b.t-b.h/2-ty);
  tx-=ox*(r-1); ty-=oy*(r-1); sc=ns; apply();
}
function zoomBy(k){var b=box();zoomAt(k,b.l+b.w/2,b.t+b.h/2);}
function toggleZoom(cx,cy){ if(sc>fit*1.02){sc=fit;tx=ty=0;apply();} else zoomAt(2.5,cx,cy); }
function go(d){if(items.length<2)return;idx=(idx+d+items.length)%items.length;render();}

function onWheel(e){e.preventDefault();zoomAt(e.deltaY<0?1.18:1/1.18,e.clientX,e.clientY);}
function d2(a,b){return Math.hypot(a.x-b.x,a.y-b.y);}
function onDown(e){
  if(e.target.closest('.xlb-nav,.xlb-b'))return;
  ptr.set(e.pointerId,{x:e.clientX,y:e.clientY}); moved=0;
  try{stage.setPointerCapture(e.pointerId);}catch(_){}
  var ps=[].slice.call(ptr.values?[]:[]); ps=Array.from(ptr.values());
  if(ps.length===2){pinch={d:d2(ps[0],ps[1]),s:sc};drag=null;}
  else if(ps.length===1){drag={x:e.clientX,y:e.clientY,tx:tx,ty:ty};}
}
function onMove(e){
  if(!ptr.has(e.pointerId))return;
  ptr.set(e.pointerId,{x:e.clientX,y:e.clientY});
  var ps=Array.from(ptr.values());
  if(ps.length===2&&pinch&&pinch.d){
    e.preventDefault();
    var ns=Math.max(fit,Math.min(fit*8,pinch.s*(d2(ps[0],ps[1])/pinch.d)));
    var b=box(), cx=(ps[0].x+ps[1].x)/2, cy=(ps[0].y+ps[1].y)/2, r=ns/sc;
    tx-=(cx-b.l-b.w/2-tx)*(r-1); ty-=(cy-b.t-b.h/2-ty)*(r-1); sc=ns; moved=1; apply(); return;
  }
  if(ps.length===1&&drag){
    var dx=e.clientX-drag.x, dy=e.clientY-drag.y;
    if(Math.abs(dx)+Math.abs(dy)>6)moved=1;
    if(sc>fit*1.02){e.preventDefault();tx=drag.tx+dx;ty=drag.ty+dy;apply();}
    else if(!FINE&&Math.abs(dy)>Math.abs(dx)&&Math.abs(dy)>8){
      e.preventDefault(); drag.dy=dy;
      ov.classList.add('dragging'); ov.style.setProperty('--xlb-dy',dy+'px');
      ov.style.setProperty('--xlb-fade',String(Math.max(.25,1-Math.abs(dy)/420)));
    }
  }
}
function onUp(e){
  var d=drag; ptr.delete(e.pointerId);
  if(ptr.size<2)pinch=null;
  if(ptr.size)return;
  if(ov.classList.contains('dragging')){
    ov.classList.remove('dragging'); ov.style.removeProperty('--xlb-dy'); ov.style.removeProperty('--xlb-fade');
    if(d&&Math.abs(d.dy||0)>90){drag=null;close();return;}
  }
  if(!moved&&!FINE&&d){                     /* 触屏:双击缩放 */
    var now=Date.now();
    if(now-lastTap<300){lastTap=0;toggleZoom(e.clientX,e.clientY);}else lastTap=now;
  }
  drag=null;
}
function onKey(e){
  if(!ov.classList.contains('on'))return;
  var k=e.key;
  if(k==='Escape'){e.preventDefault();close();}
  else if(k==='ArrowRight'){e.preventDefault();go(1);}
  else if(k==='ArrowLeft'){e.preventDefault();go(-1);}
  else if(k==='+'||k==='='){e.preventDefault();zoomBy(1.6);}
  else if(k==='-'||k==='_'){e.preventDefault();zoomBy(1/1.6);}
  else if(k==='0'){e.preventDefault();sc=fit;tx=ty=0;apply();}
}

/* 点击时实时判定:懒加载/异步CSS 会让首次收集时宽度=0,不能只信预收集的名单 */
function fire(im){
  collect();
  var i=items.indexOf(im);
  if(i<0){ if(!ok(im))return; items=[im]; i=0; }
  open(i);
}
function bind(){
  var sp=scope();
  collect();
  sp.addEventListener('click',function(e){
    var im=e.target.closest&&e.target.closest('img');
    if(!im||!sp.contains(im)||!ok(im))return;
    e.preventDefault(); e.stopPropagation(); fire(im);
  },true);
  sp.addEventListener('keydown',function(e){
    if(e.key!=='Enter'&&e.key!==' ')return;
    var im=e.target.closest&&e.target.closest('img');
    if(!im||!ok(im))return; e.preventDefault(); fire(im);
  });
  var tries=0;
  (function retry(){ collect(); if(items.length||tries++>6)return; setTimeout(retry,300*tries); })();
  addEventListener('load',function(){collect();},{passive:true});
  addEventListener('scroll',recollect,{passive:true,once:true});
  if(FINE){
    hint=document.createElement('div'); hint.className='xlb-hint'; hint.textContent=C.hint||'Click to enlarge';
    document.documentElement.appendChild(hint);
    sp.addEventListener('pointerover',function(e){
      var im=e.target.closest&&e.target.closest('img');
      if(im&&ok(im)){
        positionHint(e);hintOn=1;hint.classList.add('on');
      }else hideHint();
    },{passive:true});
    sp.addEventListener('pointermove',function(e){
      if(!hintOn)return; hx=e.clientX; hy=e.clientY;
      if(hintRaf)return;
      hintRaf=requestAnimationFrame(function(){hintRaf=0;if(hintOn)positionHint();});
    },{passive:true});
    sp.addEventListener('pointerout',function(e){
      var r=e.relatedTarget;
      if(!r||!r.closest||!r.closest('img'))hideHint();
    },{passive:true});
    sp.addEventListener('pointerleave',hideHint,{passive:true});
    addEventListener('scroll',hideHint,{passive:true});
    addEventListener('blur',hideHint);
  }
  addEventListener('resize',function(){if(ov&&ov.classList.contains('on'))fixCover();},{passive:true});
  try{new MutationObserver(recollect).observe(sp,{childList:true,subtree:true});}catch(e){}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind);
else bind();
})();
